import React, { useEffect, useState } from 'react'
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts'
import { AnalysisStyles } from './AnalysisStyles'
import Text from '../../../../components/text/Text'
import { getHomeDataGraphics } from '../../../../services/amipos'
import SvgIcon from '../../../../components/svgIcon/SvgIcon'
import { useNavigate } from 'react-router-dom'
import routes from '../../../../router/routes'

export function AnalysisComponent() {
    const [data, setData] = useState([
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
        { name: '', Monto: 0 },
    ])

    const navigate = useNavigate()

    useEffect(() => {
        getHomeDataGraphics()
            .then(async (success: { data: number[] }) => {
                const updatedData = success.data.map((amount: any, index) => ({
                    name: amount.name.substring(0, 3),
                    Monto: amount.amount,
                    month: amount.month,
                    longName: amount.name,
                }))
                setData(updatedData)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])

    const CustomTooltip = ({ active, payload }: any) => {
        if (active && payload && payload.length) {
            const { Monto, month, longName } = payload[0].payload
            return (
                <div
                    style={{
                        backgroundColor: '#fff',
                        border: '1px solid #ccc',
                        padding: 10,
                        borderRadius: 5,
                    }}
                >
                    <p
                        style={{ margin: 0, fontWeight: 'bold' }}
                    >{`${longName} ${month?.split('-')[0]}`}</p>
                    <p style={{ margin: 0 }}>{`Monto: ${Monto.toLocaleString(
                        'es-ES'
                    )}`}</p>
                </div>
            )
        }
        return null
    }

    return (
        <div style={AnalysisStyles.container}>
            <Text
                label="Análisis de tu negocio"
                marginBottom={20}
                fontWeight={600}
                color="#184287"
                fontSize={19}
            />
            <div style={AnalysisStyles.content}>
                <ResponsiveContainer height={300}>
                    <AreaChart
                        data={data}
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                        <defs>
                            <linearGradient
                                id="colorGradient"
                                x1="0"
                                y1="0"
                                x2="0"
                                y2="1"
                            >
                                <stop
                                    offset="0%"
                                    stopColor="#2699D6"
                                    stopOpacity={0.9}
                                />
                                <stop
                                    offset="100%"
                                    stopColor="#ffffff"
                                    stopOpacity={0.1}
                                />
                            </linearGradient>
                        </defs>
                        <CartesianGrid
                            vertical={false}
                            stroke="#E0E0E0"
                            strokeWidth={0.5}
                        />
                        <XAxis
                            dataKey="name"
                            tick={{
                                fontSize: 14,
                                fill: '#000',
                                fontFamily: 'Nunito',
                            }}
                            interval={0}
                        />

                        <YAxis
                            dataKey="Monto"
                            tick={{
                                fontSize: 14,
                                fill: '#000',
                                fontFamily: 'Nunito',
                            }}
                            interval={0}
                            tickFormatter={(value) =>
                                value.toLocaleString('es-ES')
                            }
                        />
                        <Tooltip content={<CustomTooltip />} />
                        <Area
                            type="monotone"
                            dataKey="Monto"
                            stroke="#2699D6"
                            fill="url(#colorGradient)"
                            strokeWidth={2}
                        />
                    </AreaChart>
                </ResponsiveContainer>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 10,
                }}
            >
                <button
                    style={AnalysisStyles.buttonViewFullAnalysis}
                    onClick={() => navigate(`/${routes.urlDashboard}`)}
                >
                    <span style={AnalysisStyles.textFullAnalysis}>
                        <SvgIcon
                            width={15}
                            height={15}
                            iconName="IconPadlock"
                        />
                        <Text
                            label="Ver Análisis Completo"
                            fontSize={12}
                            fontWeight={500}
                            textAlign="center"
                            color="#0086d6"
                            marginLeft={10}
                        />
                    </span>
                    <div style={AnalysisStyles.buttonSeparator}></div>
                    <span style={AnalysisStyles.iconChevronDown}>
                        <SvgIcon
                            width={15}
                            height={15}
                            iconName="IconChevronDown"
                        />
                    </span>
                </button>
            </div>
        </div>
    )
}
